import { connectLoadable } from 'helpers/loadableHelpers'
import OnboardingSummary, { OnboardingSummaryStateProps } from 'components/features/pfm/OnboardingSummary/OnboardingSummary'
import PageLoadingOverlay from 'components/atoms/preloaders/PageLoadingOverlay'
import { Guards } from 'interfaces/guards'
import { peergroupsGuard } from 'guards/globalGuards'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { yourPeergroupSelector } from 'selectors/peergroupSelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import internal from 'components/utils/Internal'
import { RouteComponentProps, withRouter } from 'react-router'
import { State } from 'interfaces/state'
import { RETURN_URL_PARAM_NAME } from 'constants/pages'
import { extractGetParam } from 'helpers/utilsHelpers'

type OnboardingSummaryContainerInnerProps = RouteComponentProps<{}>

const mapStateToProps = (state: State, ownProps: OnboardingSummaryContainerInnerProps) => {
  const member = memberInfoSelector(state)
  const peers = yourPeergroupSelector(state)

  if (!member) {
    throw createForgottenGuardError('OnboardingSummaryContainer', 'memberInfoGuard')
  }

  if (!peers) {
    throw createForgottenGuardError('OnboardingSummaryContainer', 'peergroupsGuard')
  }

  const returnUrlDecoded = extractGetParam(ownProps.location.search, RETURN_URL_PARAM_NAME)

  return {
    member,
    peers,
    returnUrl: returnUrlDecoded,
  }
}

const onboardingSummaryGuards: Guards = [
  peergroupsGuard,
]

const OnboardingSummaryContainerInner = internal(
  connectLoadable<OnboardingSummaryStateProps>(
    onboardingSummaryGuards, PageLoadingOverlay
  )(mapStateToProps)(OnboardingSummary)
)
const OnboardingSummaryContainer = withRouter(OnboardingSummaryContainerInner)

export default OnboardingSummaryContainer
